import { SlotComponentProps } from '@mui/base/utils';
import { Dayjs } from 'dayjs';
import { forwardRef } from 'react';
import { DatePickerProps as MuiDatePickerProps } from '@mui/x-date-pickers/DatePicker/DatePicker.types';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker/DatePicker';
import TextField2 from '../TextField2';
import { DataElmObj } from '../theme/types';

type TextFieldProps = SlotComponentProps<typeof TextField2, Record<string, unknown>, Record<string, unknown>> &
  DataElmObj;

export interface DatePickerProps<T = Dayjs> extends Omit<MuiDatePickerProps<T>, 'slotProps'> {
  slotProps?: Omit<MuiDatePickerProps<T>['slotProps'], 'textField'> & {
    textField?: TextFieldProps;
  };
}

const DatePicker = forwardRef<HTMLInputElement, DatePickerProps>(({ slots, slotProps, ...props }, ref) => {
  // make sure that the 'data-elm' attribute is passed to the input
  const elmId = (props as DataElmObj)['data-elm'];

  return (
    <MuiDatePicker
      inputRef={ref}
      slots={{
        ...slots,
        textField: slots?.textField || TextField2,
      }}
      slotProps={{
        ...slotProps,
        textField: {
          'data-elm': elmId,
          variant: 'outlined',
          ...slotProps?.textField,
        } as TextFieldProps,
      }}
      orientation="portrait"
      {...props}
    />
  );
});

DatePicker.displayName = 'DatePicker';

export default DatePicker;
